<template>
    <div class="body">
        <vue-particles class="login-bg" color="#fff" :particleOpacity="1" :particlesNumber="80" shapeType="circle" :particleSize="4" linesColor="#fff" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4" :linesDistance="150" :moveSpeed="2" :hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push">
        </vue-particles>
        <div class="centerbox">
            <div class="h1">
                <div>体育百姓运动码</div>
                <div>让体育和生活更美好！</div>
            </div>
            <div class="left">
                <img src="../assets/img/fengmian.png" alt="" class="img">
            </div>
            <div class="right">
                <div class="title">
                    百姓运动码管理系统
                </div>
                <div class="fromdata">
                    <el-form :rules="loginFormRules" ref="LoginFormRef" :model="loginForm">
                        <div class="input">
                            <el-form-item prop="username">
                                <el-input class="inputname" prefix-icon="iconfont icon-user" tabindex="1" type="text" autocomplete="on" v-model="loginForm.username" placeholder="Username" clearable></el-input>
                            </el-form-item>
                        </div>
                        <div class="input">
                            <el-form-item prop="userpass">
                                <el-input class="inputname" prefix-icon="iconfont icon-3702mima" tabindex="2" autocomplete="on" placeholder="Password" v-model="loginForm.userpass" :type="passwordType" :key="passwordType" @keyup.enter.native="routerhome" show-password clearable></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                    <div class="btn" @click="routerhome">
                        登录
                    </div>
                    <div class="wangjimima">
                        忘记密码
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { initDynamicRoutes } from '@/router/index'
    import { login } from '@/api/login'
    export default {
        name: 'login',
        data() {
            return {
                loginForm: {
                    username: '',
                    userpass: ''
                },
                passwordType: 'password',
                loginFormRules: {
                    username: [
                        { required: true, message: '请输入登录名', trigger: 'blur' },
                        {
                            min: 3,
                            max: 15,
                            message: '登录名长度在 3 到 15 个字符',
                            trigger: 'blur'
                        }
                    ],
                    userpass: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        {
                            min: 6,
                            max: 15,
                            message: '密码长度在 6 到 15 个字符',
                            trigger: 'blur'
                        }
                    ]
                }
            }
        },
        methods: {
            routerhome() {
                login(this.loginForm).then(({ data: res }) => {
                    console.log('res', res)
                    if (res.result === 0) {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: '2000'
                        })
                        return false
                    }
                    if (res.result === 1) {
                        window.sessionStorage.setItem('token', res.token)
                        this.$store.commit('setRightList', res.menu_list)
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            duration: '2000'
                        })
                        initDynamicRoutes()
                        setTimeout(() => {
                            // 导航至/home
                            this.$router.push('/home')
                        }, 500)
                    }
                }).catch(error => {
                    console.log(error)
                })
            }
        }
    }
</script>

<style scoped lang="less">
    .body {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        //padding: 10%;
        background: #000000;
        background-repeat: no-repeat;
        background-position: center right;
        background-size: cover;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        .login-bg {
            width: 100%;
            height: 100%;
            background: #3E3E3E;
        }

        .centerbox {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 9999;
            width: 49.9rem;
            height: 23.5rem;
            //background: red;
            border-radius: 0.6rem;
            box-shadow: 0px 20px 30px 0px rgba(57, 57, 57, 0.02);
            display: flex;
            flex-direction: row;
            align-items: center;

            .h1 {
                position: absolute;
                left: 0;
                top: -100px;
                width: 100%;
                line-height: 40px;
                text-align: center;
                color: #fff;
                font-size: 20px;
            }

            .left {
                width: 24.95rem;
                height: 23.5rem;
                opacity: 1;
                //background: linear-gradient(135deg,#3d9aff, #3380f2);
                //background: url("../assets/img/fengmian.png") no-repeat;
                //background-size: cover;
                border-radius: 0.6rem 0px 0px 0.6rem;
                box-shadow: 0px 1rem 1.5rem 0px rgba(57, 57, 57, 0.02);

                .img {
                    width: 100%;
                    height: 100%;
                }
            }

            .right {
                width: 24.95rem;
                height: 23.5rem;
                opacity: 1;
                background: #ffffff;
                border-radius: 0px 12px 12px 0px;
                box-shadow: 0px 20px 30px 0px rgba(57, 57, 57, 0.02);
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;

                .title {
                    margin-top: 4rem;
                    font-size: 30px;
                    font-family: PingFang SC, PingFang SC-Heavy;
                    font-weight: 800;
                    text-align: left;
                    color: #2e2e2e;
                    letter-spacing: 0px;
                }

                .fromdata {
                    margin-top: 2.05rem;
                    width: 24.95rem;
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .input {
                        width: 294px;
                        height: 44px;
                        opacity: 1;
                        background: #fbfbfb;
                        border-radius: 0.25rem;
                        margin-bottom: 1.3rem;

                        .el-input__inner {
                            background: #fbfbfb !important;
                            border: none;
                        }
                    }

                    .btn {
                        width: 295px;
                        height: 44px;
                        opacity: 1;
                        background: linear-gradient(135deg, #3d9aff, #3380f2);
                        border-radius: 5px;
                        font-size: 16px;
                        font-family: PingFang SC, PingFang SC-Regular;
                        font-weight: 400;
                        text-align: left;
                        color: #ffffff;
                        letter-spacing: 0px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                    }

                    .btn:hover {
                        opacity: 0.8;
                    }

                    .wangjimima {
                        margin-top: 0.6rem;
                        width: 295px;
                        height: 17px;
                        opacity: 1;
                        font-size: 12px;
                        font-family: PingFang SC, PingFang SC-Regular;
                        font-weight: 400;
                        text-align: left;
                        color: #3d9aff;
                        letter-spacing: 0px;
                        display: flex;
                        flex-direction: row;
                        cursor: pointer;
                    }

                    .wangjimima:hover {
                        opacity: 0.8;
                    }
                }
            }
        }
    }
</style>
